function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M147.78,88.68c41.33,0,70.18,16.09,99.4,45.31l15.38,15.38a4,4,0,0,1,0,5.69l-9.85,9.84c-29.56,29.57-59.6,46.66-101.41,46.42-41-.24-69.47-16.31-98.48-45.31L37.44,150.63a4,4,0,0,1,0-5.69l11-10.95c29.22-29.22,58.07-45.31,99.39-45.31m0-17C103.84,71.68,69.9,88.44,36.37,122L16.23,142.11a8,8,0,0,0,0,11.35L40.8,178c33.53,33.53,67.47,50.29,111.42,50.29S230.1,211.56,263.63,178l20.14-20.14a8,8,0,0,0,0-11.35L259.2,122c-33.53-33.53-67.47-50.29-111.42-50.29Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M150.51,118a30.17,30.17,0,1,1-30.17,30.17A30.2,30.2,0,0,1,150.51,118m0-17a47.17,47.17,0,1,0,47.16,47.17A47.17,47.17,0,0,0,150.51,101Z"
});

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.064a8d4f.svg";
export { ForwardRef as ReactComponent };